module.exports = __webpack_public_path__ + "static/img/8.1d75ffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/8.png
// module id = nI4g
// module chunks = 0